<template>
  <div ref="main" class="l-query2">
    <el-form :model="formData" size="mini" :inline="true" ref="form">
      <input type="text" style="display: none" />
      <span
        style="display: inline-block"
        v-for="(item, index) in showItems"
        :key="index"
        ref="itemsRef"
      >
        <el-form-item
          :label="$t(item.label)"
          :ref="item.prop"
          :prop="item.prop"
        >
          <slot :name="item.prop"></slot>
        </el-form-item>
      </span>
      <el-form-item ref="lQueryBtns" style="margin-right: 0">
        <el-button
          style="margin-right: 8px"
          size="mini"
          type="text"
          icon="el-icon-arrow-down"
          v-if="showMore"
          @click="popoverVisible = !popoverVisible"
        >
          {{ popoverVisible ? $t("收起条件") : $t("更多条件") }}
        </el-button>
        <el-button
          v-if="openComplexQuery"
          @click="complexVisible = !complexVisible"
          size="mini"
          icon="el-icon-s-operation"
        ></el-button>
        <el-button @click="handleResetClick" size="mini">{{
          $t("重置")
        }}</el-button>
        <el-button
          @click="handleSearchClick"
          size="mini"
          type="primary"
          :loading="loading"
          >{{ $t("查询") }}</el-button
        >
      </el-form-item>
    </el-form>

    <l-drawer
      :title="$t('更多条件')"
      :width="popoverWidth"
      :showClose="false"
      :okBtnLabel="$t('查询')"
      v-if="showMore"
      :visible.sync="popoverVisible"
      @ok="handleSearchClick"
    >
      <div class="l-query-popper">
        <el-form
          :model="formData"
          size="mini"
          ref="popperForm"
          :label-width="`${labelWidth}px`"
        >
          <template v-for="(item, index) in hideItems">
            <el-col :span="item.span || 24" :key="index">
              <el-form-item
                :label="item.label"
                :ref="item.prop"
                :prop="item.prop"
              >
                <slot :name="item.prop"></slot>
              </el-form-item>
            </el-col>
          </template>
        </el-form>
      </div>
    </l-drawer>
  </div>
</template>
<script>
var elementResizeDetectorMaker = require("element-resize-detector");
export default {
  name: "l-query2",
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    labelWidth: {
      type: Number,
      default: 120,
    },
    openComplexQuery: {
      type: Boolean,
      default: false,
    },
    popoverWidth: {
      type: Number,
      default: 600,
    },
    items: {
      type: Array,
      default: () => [],
    },
    formData: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      complexVisible: false,
      showNum: this.items.length,
      myItems: this.items,
      oldDataItems: this.$deepClone(this.items),
      erdUltraFast: null,
      width: 0,
      btnWidth: 0,
      btnNotMoreWidth: 0,
      showMore: false,
      popoverVisible: false,
      formDataInit: this.$deepClone(this.formData),
      isresize: false,
      queryIndex: 0,
      itemId: "",
    };
  },
  async mounted() {
    this.itemId = this.md5Object(this.items);
    for (
      var n = 0;
      n < document.getElementsByClassName("l-query2").length;
      n++
    ) {
      if (this.$el == document.getElementsByClassName("l-query2")[n]) {
        var r = {
          path: this.$router.currentRoute.path,
          queryIndex: n,
          id: this.itemId,
        };
        let a = await window.$api.system.module.getQueryData(r);
        if (
          null != a.data.data &&
          null != a.data.data &&
          "" != a.data.data &&
          a.data.data.id == this.itemId
        ) {
          var od = JSON.parse(a.data.data.queryData);
          this.oldDataItems = od;
          this.myItems = od.filter(
            (item) => item.visble == undefined || item.visble == true
          );
        }
      }
    }
    this.init();
  },
  beforeDestroy() {
    this.erdUltraFast.removeAllListeners(this.$refs.main);
    this.erdUltraFast.uninstall(this.$refs.main);
    this.erdUltraFast = null;
  },
  computed: {
    showItems() {
      let len = this.myItems.length;
      if (len <= this.showNum) {
        return this.myItems;
      } else {
        const list = [];
        this.myItems.forEach((item, index) => {
          if (index < this.showNum) {
            list.push(item);
          } else {
            return false;
          }
        });
        return list;
      }
    },
    hideItems() {
      let len = this.myItems.length;
      if (len <= this.showNum) {
        return [];
      } else {
        const list = [];
        this.myItems.forEach((item, index) => {
          if (index >= this.showNum) {
            list.push(item);
          }
        });
        return list;
      }
    },
  },
  methods: {
    handleClearExpression: function () {
      this.formData.complexQueryString = null;
    },
    handleSaveExpression(query) {
      this.formData.complexQueryString = query;
    },
    handleComplexQuery(query) {
      this.formData.complexQueryString = query;
      this.complexVisible = false;
      this.$emit("search", this.$deepClone(this.formData));
    },

    handleSortSetClick() {
      var e = this;
      for (
        var t = 0;
        t < document.getElementsByClassName("l-query2").length;
        t++
      ) {
        if (this.$el == document.getElementsByClassName("l-query2")[t]) {
          this.queryIndex = t;
          this.$modal({
            methods: {
              saveData: (t) => {
                e.oldDataItems = t;
                e.myItems = t.filter(
                  (item) => item.visble == undefined || item.visble
                );
              },
              resetData: () => {
                e.oldDataItems = this.$deepClone(e.items);
                e.myItems = e.items;
              },
            },
            componentProps: {
              id: e.itemId,
              tableData: e.oldDataItems,
              queryIndex: e.queryIndex,
              path: e.$router.currentRoute.path,
            },
          });
        }
      }
    },
    handleResetClick() {
      for (var id in this.formDataInit) {
        this.$set(this.formData, id, this.formDataInit[id]);
      }
      this.$nextTick(() => {
        this.handleSearchClick();
      });
    },
    handleSearchClick() {
      this.popoverVisible = false;
      this.$emit("search", this.$deepClone(this.formData));
    },
    init() {
      this.btnWidth = this.$getElemWidth(this.$refs.lQueryBtns.$el) + 17;
      this.items.forEach((item) => {
        item._width = this.$getElemWidth(this.$refs[item.prop][0].$el) + 10; // 10 右外边距
      });
      this.$nextTick(() => {
        this.erdUltraFast = elementResizeDetectorMaker({
          strategy: "scroll", //<- For ultra performance.
        });
        this.erdUltraFast.listenTo(this.$refs.main, () => {
          this.dolayout();
        });
      });
    },

    resize(e) {
      var t = this;

      this.$nextTick(() => {
        let itemsRefWidth = 0;
        if (Array.isArray(t.$refs.itemsRef)) {
          t.$refs.itemsRef.forEach((item) => {
            itemsRefWidth += Number(t.$getElemWidth(item));
          });
        } else {
          itemsRefWidth = Number(t.$getElemWidth(t.$refs.itemsRef.$el));
        }
        let formWidth = t.$getElemWidth(t.$refs.form.$el);
        let lQueryBtnsWidth = t.$getElemWidth(t.$refs.lQueryBtns.$el);
        // 添加2px误差和8边距
        itemsRefWidth + lQueryBtnsWidth + 10 > formWidth && t.showNum > 0
          ? (t.showNum--, t.resize(e))
          : t.myItems.length > t.showNum && !e
          ? ((t.showMore = !0), t.resize(!0))
          : (t.isresize = !1);
      });
    },
    dolayout() {
      this.showNum = this.myItems.length;
      this.popoverVisible = !1;
      this.isresize ||
        ((this.isresize = !0), (this.showMore = !1), this.resize(!1));
    },
  },
};
</script>
<style lang="less">
@import "./index.less";
</style>
